﻿import { Page, Layout, BlockStack, Card, Text, Link } from '@shopify/polaris'
import { AiUsageStats } from '@/components/ai/AiUsageStats'
import { AuditLogTable } from '@/components/audit/AuditLogTable'
import { NotificationPreferencesPanel } from '@/components/notifications/NotificationPreferencesPanel'

export function SettingsPage() {
  return (
    <Page fullWidth title="Settings">
      <Layout>
        <Layout.Section>
          <BlockStack gap="400">
            <Card>
              <BlockStack gap="300">
                <Text as="h2" variant="headingMd">
                  Notifications
                </Text>
                <NotificationPreferencesPanel />
              </BlockStack>
            </Card>

            <Card>
              <BlockStack gap="300">
                <Text as="h2" variant="headingMd">
                  AI Usage
                </Text>
                <AiUsageStats />
              </BlockStack>
            </Card>

            <Card>
              <BlockStack gap="300">
                <Text as="h2" variant="headingMd">
                  Activity Log
                </Text>
                <AuditLogTable />
              </BlockStack>
            </Card>

            <Text as="p" variant="bodySm" tone="subdued">
              <Link onClick={() => window.open('/privacy', '_blank')}>Privacy Policy</Link>
            </Text>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </Page>
  )
}
